var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-img",class:_vm.numClass,style:(_vm.numStyle)},[_vm._v(" "+_vm._s(_vm.imgUrl ? '' : _vm.numberText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }